import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import styled from "styled-components";

export const HeaderContainer = styled(Box)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  cursor: pointer;
`;

export const HeaderTitle = styled(Typography)`
  color: ${(props) => props.theme.text.light};
  font-size: 20px;
  font-family: "Outfit-SemiBold";
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
